import React, {Component,} from "react"
import {
   FaFileImage,
} from 'react-icons/fa';
import '../../css/Settings.css'
import {FiEdit} from 'react-icons/fi';
import {MdOutlineCrop} from 'react-icons/md';
import {Avatar, Grid} from "@mui/material";
import { styled} from '@mui/material/styles';
import Modal from "@mui/material/Modal";
import Fade from "@mui/material/Fade";
import Box from "@mui/material/Box";
import Badge from "@mui/material/Badge";
import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";
import CloseIcon from '@mui/icons-material/Close';
import Typography from "@mui/material/Typography";
import {Slider} from '@mui/material'
import Cropper from 'react-easy-crop';
import create_image_edit from "../common/common/create_image_edit";
import get_and_post_data_skeleton from '../common/common/get_and_post_data_skeleton';
import {IoClose} from "react-icons/io5";

const CustomSlider = styled(Slider)(({ theme }) => ({
   color: 'var(--brand-color)', //color of the slider between thumbs
   "& .MuiSlider-rail": {
     color: 'var(--brand-color)' ////color of the slider outside  teh area between thumbs
   }
 }));

const paths = require('../../paths.json');

const style = {
   outline: 0,
   border: 'none',
   top: '50%',
   left: '50%',
   transform: 'translate(-50%, -50%)',
   width: 400,
   boxShadow: 24,
   p: 4,
};

/* props needed
   url - the url to get the current file
   image - a file to use instead of a fetch
   onLogoExit - function which is called on exit
   onImageBase64 - called when the image is base64 decoded
   size - 'mini' for small version, undefined for normal size
*/
class SettingsIconImageDiv extends Component {
   constructor(props) {
      super(props);
      this.state = {
         imageFile: '',
         imageBase64: '',
         user_id: undefined,
         newPath: '',
         currentImage: false,
         editIconImageOn: false,
         invalidIconFile: false,
         zoomCropIconImage: false,
         zoomCropHeaderImage: false,
         zoomCropInfo: {x: 0, y: 0, width: 0, height: 0},
         crop: {x: 0, y: 0},
         zoom: 1,
         bottomMobilePadding: window.innerWidth<600 ? '20px 0 100px 0' : '20px 0 0 0',
         cropperHeight: window.innerWidth < 600 ? '350px': 'unset'
      };
      this.EditCropZoomIconImageOn = this.EditCropZoomIconImageOn.bind(this)
      this.get_and_post_data_skeleton = this.get_and_post_data_skeleton.bind(this);
      this.create_image_edit = this.create_image_edit.bind(this);
      this.handleBottomMobilePadding = this.handleBottomMobilePadding.bind(this);
   }

   get_and_post_data_skeleton = get_and_post_data_skeleton

   componentDidMount() {
      if (this.props.url) {
         // The url has changed!
         this.getFileFromUrl(`${paths.BACKEND_URL}api/user/icon`);
      }
      window.addEventListener('resize', this.handleBottomMobilePadding);
   }

   componentDidUpdate(prevProps, prevState) {
      // Need to check a few things
      if (prevProps.url !== this.props.url) {
         // The url has changed!
         if (prevProps.url === ''){
            this.getFileFromUrl(`${paths.BACKEND_URL}api/user/icon`);
         }
      }
      if (prevState.imageFile !== this.state.imageFile) {
         // Convert the file to a base64 for the editors
         this.imageToBase64(this.state.imageFile);
      }
      if (this.props.onImageBase64 && prevState.imageBase64 !== this.state.imageBase64) {
         this.props.onImageBase64(this.state.imageBase64);
      }
   }

   componentWillUnmount() {
      window.removeEventListener('resize', this.handleBottomMobilePadding);
   }

   async getFileFromUrl(url) {
      const resizedImage = await new Promise((resolve, reject) => {
         const image = new Image();
         image.setAttribute('crossOrigin', 'use-credentials');
         image.onload = (imageEvent) => {
            // Resize the image
            const canvas = document.createElement('canvas');
            let width = image.width;
            let height = image.height;
            canvas.width = width;
            canvas.height = height;
            canvas.getContext('2d').drawImage(image, 0, 0, width, height);
            canvas.toBlob(resolve, 'image/jpeg');
         }
         image.src = url;
      })
      this.setState({imageFile: resizedImage})
      return resizedImage
   }

   async imageToBase64(file) {
      return new Promise((resolve, reject) => {
         const reader = new FileReader();
         if (
            (
               String(file.type).endsWith('jpg')
            ) || (
               String(file.type).endsWith('jpeg')
            ) || (
               String(file.type).endsWith('png')
            )
         ) {
            reader.onload = (e) => resolve(e);
            reader.onerror = (e) => reject(e);
            this.setState({invalidIconFile: false});
         } else {
            this.setState({invalidIconFile: true});
         }
         reader.readAsDataURL(file); // convert to base64 string
      }).then((e) => {
         this.setState({imageBase64: e.target.result})
      })
   }

   handleBottomMobilePadding() {
      window.innerWidth<600 ? this.setState({bottomMobilePadding:'20px 0 100px 0'}) : 
      this.setState({bottomMobilePadding:'20px 0 0 0'})
      window.innerWidth < 600 ? this.setState({cropperHeight:'350px'}) : 
      this.setState({cropperHeight:'unset'})
   }

   EditIconImageOn() {
      this.setState({editIconImageOn: true})
   }

   EditIconImageOff() {
      this.setState({editIconImageOn: true})
   }

   EditCropZoomIconImageOn(event) {
      this.setState({zoomCropIconImage: true})
      this.setState({zoom: 1})
      this.setState({crop: {x: 0, y: 0}})
      this.setState({zoom_crop_info: {x: 0, y: 0, width: 0, height: 0}})
   }

   async EditCropZoomIconImageOff(event) {
      try {
         const image = await new Promise((resolve, reject) => {
            const image = new Image()
            image.addEventListener('load', () => resolve(image))
            image.addEventListener('error', (error) => reject(error))
            image.setAttribute('crossOrigin', 'anonymous') // needed to avoid cross-origin issues on CodeSandbox
            image.src = this.state.imageBase64
         })
         var canvas = document.createElement('canvas');
         canvas.width = 512;
         canvas.height = 512;
         var canvas_context = canvas.getContext('2d')
         canvas_context.drawImage(
            image,
            this.state.zoomCropInfo['x'],
            this.state.zoomCropInfo['y'],
            this.state.zoomCropInfo['width'],
            this.state.zoomCropInfo['height'],
            0,
            0,
            canvas.width,
            canvas.height,
         )
         this.setState({
            imageBase64: canvas.toDataURL('image/jpeg'),
            zoomCropIconImage: false
         })
      } catch (err) {
         // console.log(err)
      }
   }

   changeIconImageFilePreview(event) {
      if (event.target.files && event.target.files[0]) {
         this.setState({imageFile: event.target.files[0]})

      }
   }

   UpdateIconImagePush(event) {
      event.preventDefault();
      const form_data = new FormData();
      form_data.append('icon_image', this.state.imageBase64);
      this.get_and_post_data_skeleton(
         paths.BACKEND_URL + 'api/settings_post_processing/',
         'post',
         false,
         form_data,
         (res) => {
            // this.getFileFromUrl(res.data.current_user_icon);
            this.setState({editIconImageOn: false})
            if (this.props.onUpdate && typeof this.props.onUpdate == 'function') {
               this.props.onUpdate(res.data.current_user_icon);
            }
         },
      )
   }

   create_image_edit = create_image_edit

   render() {
      const avatarSize = this.props.size === 'mini' ? '100px' : '150px';
      const editButtonSize = this.props.size === 'mini' ? '35px' : '35px';
      const editButtonMarginLeft = this.props.size === 'mini' ? '15px' : '40px';

      let social_media_divs = (<div></div>);
      let settings_main_div = (<div></div>);
      if (this.state.editIconImageOn) {

         let icon_image_invalid_file_type_div = "";
         if (this.state.invalidIconFile) {
            icon_image_invalid_file_type_div = (
               <div className="settings_upload_icon_image_invalid_file_text">
                  Upload failed due to invalid file type
               </div>
            )
         }
         if (this.state.zoomCropIconImage) {
            settings_main_div = (
               <Modal
               open={this.state.zoomCropIconImage}
               aria-labelledby="modal-modal-title"
               aria-describedby="modal-modal-description"
               sx={{ overflow: 'auto', paddingBottom: '40px', margin:'auto', display:'flex' }}
               className='crop-modal-dashbaord'
            >
               <Fade
                  style={{
                     borderRadius: '0px',
                     border: 'none',
                     boxShadow: 'none',
                     outline: 'none',
                  }}
                  in={this.state.zoomCropIconImage}
               >
                  <Grid
                     xs={12}
                     container
                     item
                     justifyContent="center"
                     height={'100%'}
                  >
                     <Grid
                        container
                        lg={6}
                        md={8}
                        sm={10}
                        xs={12}
                        style={{
                           padding: this.state.bottomMobilePadding,
                           backgroundColor: 'var(--rebranding-content-background-color)',
                           borderRadius: '5px',
                           margin:'auto 20px'
                        }}
                        justifyContent="center"
                     >
                                             <Grid
                     container
                     xs={12}
                     style={{
                        padding: '0px',
                        height: '60px',
                        paddingTop: '0px',
                        borderRadius: '0px',
                        backgroundColor: 'var(--rebranding-content-background-color)',
                        borderTopLeftRadius : '5px',
                        borderTopRightRadius : '5px',
                     }}
                     > 
                        <Grid
                           item
                           xs={10}
                           style={{
                              height: '40px',
                              width: '40px',
                              paddingLeft: '10%',
                           }}
                        >
                   
                           <Typography
                           style={{
                              color: 'var(--light-theme-text-color)',
                              fontSize: '26px',
                
                              fontWeight: '600',
                              paddingTop: '5px',position: window.innerWidth > 420 ? 'absolute' : 'relative',
                              textAlign: 'center',
                              left: window.innerWidth > 420 ? '50%' : 'unset',
                              right: window.innerWidth > 420 ? '50%' : 'unset',
                              width: '100%',
                              transform: window.innerWidth > 420 ? 'translateX(-50%)' : 'translateX(0)'
                           }}
                        >
                           Crop Profile Image
                        </Typography>
                        </Grid>
                        
                        <Grid
                           item
                           xs={2}
                           style={{  
              
                              top: '0px',
                              padding: '0px',
                              float: 'right',
                              paddingRight: '20px',
                              textAlign: 'right',
  
                           }}
                        >
                              <IconButton
                                 style={{
                                    padding: '0px',
                                    margin: '0px',
                                    textAlign: 'right',
                                    color: '--light-theme-tertiary-text-color',
                                 }}
                                 onClick={
                                    () => {
                                       {
                                          this.setState({zoomCropIconImage: false})
                                       }
                                 }}
                              >
                                 <CloseIcon
                                    style={{
                                       fontSize: '30px',
                                       fontWeight: '600',
                                       textAlign: 'right',
                                       padding: '0px',
                                    }}
                                    color= '--light-theme-tertiary-text-color'
                                 />
                              </IconButton>
                        </Grid>
                     </Grid>
               
                        <Grid
                           item
                           container
                           justifyContent="center"
                           xs={12}
                           marginTop='20px'
                        >
                           <Grid
                                 item
                                 container
                                 justifyContent="center"
                                 alignItems="center"
                                 display="flex"
                                 xs={12}
                                 sx={{}}
                              >
                                 <Cropper
                                    image={this.state.imageBase64}
                                    crop={this.state.crop}
                                    zoom={this.state.zoom}
                                    aspect={1}
                                    onCropChange={(crop) => this.setState({crop: crop})}
                                    onCropComplete={(croppedArea, croppedAreaPixels) => {
                                       this.setState({zoomCropInfo: croppedAreaPixels})
                                    }}
                                    cropShape={'round'}
                                    showGrid={false}
                                    objectFit="vertical-cover"
                                    style={{
                                       containerStyle: {
                                          height: 'calc(100vh - 330px)',
                                          position: 'relative',
                                          width:'90%',
                                          maxHeight: this.state.cropperHeight
                                       },
                                    }}
                                 />
                              </Grid>
                              <Grid
                                 item
                                 container
                                 justifyContent="center"
                                 alignItems="center"
                                 display="flex"
                                 xs={12}
                              >
                                 <CustomSlider
                                    style={{
                                       width: '300px',
                                       marginLeft: 'auto',
                                       marginRight: 'auto',
                                       marginTop: '20px',
                                    }}
                                    value={this.state.zoom}
                                    min={1}
                                    max={3}
                                    step={0.1}
                                    aria-labelledby="Zoom"
                                    onChange={(e, zoom) => this.setState({zoom: zoom})}
                                    classes={{container: 'zoom_slider'}}
                                 />
                              </Grid>
                           </Grid>
                        <Button
                           fullWidth
                           variant="contained"
                           sx={{
                              backgroundColor: 'var(--brand-color)', fontSize: '14px',
                              textTransform: 'none', width: '80%', borderRadius: '6px',
                              boxShadow: 'none', marginBottom: '35px', fontWeight: '600',
                              marginTop: '30px',
                              ':hover': {
                                 bgcolor: 'var(--brand-color-hover)',
                                 color: 'white',
                                 boxShadow: 'none',
                              },
                           }}
                           className="image_update_button"
                           type="submit" value="submit"
                           // Update Password Function
                           onClick={(e) => this.EditCropZoomIconImageOff(e)}
                           >Confirm Profile Image</Button>
                     </Grid>
                  </Grid>
               </Fade>
            </Modal>
            )
         } else {
            let shortenedPath = ''
            if (this.state.imageFile && this.state.imageFile.name) {
               shortenedPath = /[^/]*$/.exec(this.state.imageFile.name)[0];
            } else {
               shortenedPath = ''
            }
            let same_image = ""
            settings_main_div = (
               <Modal
                  open={this.state.editIconImageOn}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                  sx={{ overflow: 'auto', paddingBottom: '40px' }}
                  
               >
                  <Fade
                     style={{
                        borderRadius: '0px',
                        border: 'none',
                        boxShadow: 'none',
                        outline: 'none',
                     }}
                     in={this.state.editIconImageOn}
                  >
                     <Grid
                        xs={12}
                        container
                        item
                        justifyContent="center"
                        height={'100%'}
                        
                     >
                        <Grid
                           container
                           lg={6}
                           md={8}
                           sm={10}
                           xs={12}
                           style={{
                              padding: this.state.bottomMobilePadding,
                              backgroundColor: 'var(--rebranding-content-background-color)',
                              borderRadius: '10px',
                              maxWidth: '500px',
                              margin:'auto',
                              position: 'relative'
                           }}
                           justifyContent="center"
                        >

                           <div style={{position: 'absolute', top: '10px', right: '10px', zIndex: '9999', '&:hover': {cursor: 'pointer'}}}>
                              <a onClick={() => {{this.setState({editIconImageOn: false})}}}>
                                 <IoClose className={'modal-close-icon'}/>
                              </a>
                           </div>
                                                <Grid
                        container
                        xs={12}
                        style={{
                           padding: '0px',
                           height: '60px',
                           paddingTop: '0px',
                           borderRadius: '0px',
                           backgroundColor: 'var(--rebranding-content-background-color)',
                           borderTopLeftRadius : '5px',
                           borderTopRightRadius : '5px',
                        }}
                        > 
                           <Grid
                              item
                              xs={10}
                              style={{
                                 height: '40px',
                                 width: '40px',
                                 paddingLeft: '10%',
                              }}
                           >

                              <h3
                                 style={{
                                    color: 'var(--light-theme-text-color)',
                                    fontSize: '20px',
                                    fontFamily: 'var(--main-font-family)',
                                    fontWeight: '600',
                                    paddingTop: '5px',position: window.innerWidth > 420 ? 'absolute' : 'relative',
                                    textAlign: 'center',
                                    left: window.innerWidth > 420 ? '50%' : 'unset',
                                    right: window.innerWidth > 420 ? '50%' : 'unset',
                                    width: '100%',
                                    transform: window.innerWidth > 420 ? 'translateX(-50%)' : 'translateX(0)'
                                 }}
                              >
                                 Update Profile Image
                              </h3>
                           </Grid>

                        </Grid>

                           <Grid
                              item
                              container
                              justifyContent="center"
                              xs={12}
                              marginTop='20px'
                           >
                              <Badge
                                 overlap="circular"
                                 anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}
                              >
                                 <Badge
                                    overlap="circular"
                                    anchorOrigin={{vertical: 'bottom', horizontal: 'left'}}
                                 >
                                    <Avatar
                                       alt="icon mage"
                                       style={{
                                          width: avatarSize,
                                          height: avatarSize,
                                          objectFit: 'cover',
                                          border: 'solid 1px #C6D1DE',
                                          borderRadius: '1000px'
                                       }}
                                       src={this.state.imageBase64}
                                    />
                                 </Badge>
                              </Badge>
                           </Grid>

                           <form
                              className="upload_user_icon_form"
                           >
                              <input
                                 type="file"
                                 id="upload_icon_image_filepath"
                                 className="upload_icon_image_filepath"
                                 onChange={e => this.changeIconImageFilePreview(e)}
                              />
                           </form>
                           <Typography
                              style={{
                                 width: '80%',
                                 color: '#000',
                                 fontSize: '16px',
                                 fontWeight: '600',
                                 paddingTop: '20px',
                                 textAlign: 'center',
                                 paddingBottom: '10px',
                              }}
                           >
                              {shortenedPath}
                           </Typography>

                           <Grid container columns={40} sx={{ margin: 'auto', width: '80%', justifyContent: 'space-between' }}>
                              <Grid xs={40} md={19}>
                                 <Button
                                    fullWidth
                                    variant="contained"
                                    sx={{
                                       backgroundColor: 'var(--brand-color)', fontSize: '14px',
                                       textTransform: 'none', width: '100%', borderRadius: '6px',
                                       boxShadow: 'none', fontWeight: '600',marginTop: '10px',
                                       ':hover': {
                                          bgcolor: 'var(--brand-color-hover)',
                                          color: 'white',
                                          boxShadow: 'none',
                                       },
                                    }}
                                    className="image_update_button"
                                    type="submit" value="submit"
                                    // Update Password Function
                                    onClick={
                                       (event) => {
                                          event.preventDefault();
                                          document.getElementById('upload_icon_image_filepath').click()
                                       }
                                    }
                                 >
                                    <FaFileImage style={{
                                       paddingRight: '5px',
                                       fontSize: '16px',
                                       margin: '0px',
                                    }}/>
                                    New
                                 </Button>
                              </Grid>

                              <Grid xs={40} md={19}>
                                 <Button
                                    fullWidth
                                    variant="contained"
                                    sx={{
                                       backgroundColor: 'var(--brand-color)', fontSize: '14px',
                                       textTransform: 'none', width: '100%', borderRadius: '6px',
                                       boxShadow: 'none', fontWeight: '600', marginTop: '10px',
                                       ':hover': {
                                          bgcolor: 'var(--brand-color-hover)',
                                          color: 'white',
                                          boxShadow: 'none',
                                       },
                                    }}
                                    className="image_update_button"
                                    type="submit" value="submit"
                                    // Update Password Function
                                    onClick={(e) => this.EditCropZoomIconImageOn(e)}
                                 >
                                    <MdOutlineCrop style={{
                                       paddingRight: '5px',
                                       fontSize: '16px',
                                       margin: '0px',
                                    }}/>Crop</Button>
                              </Grid>

                           </Grid>





                           <Typography
                              style={{
                                 width: '80%',
                                 color: 'var(--light-theme-text-color)',
                                 fontSize: '14px',
                                 fontWeight: '400',
                                 paddingTop: '20px',
                                 textAlign: 'center',
                              }}
                           >
                              By submitting your files to WithMe, you acknowledge that you agree to
                              WithMe's <a style={{color: 'var(--brand-color)'}} href='/terms_and_conditions'>Terms
                              & Conditions</a>
                           </Typography>
                           <Typography
                              style={{
                                 width: '80%',
                                 color: 'var(--light-theme-text-color)',
                                 fontSize: '14px',
                                 fontWeight: '400',
                                 paddingTop: '20px',
                                 textAlign: 'center',
                              }}
                           >
                              Please make sure that you do not violate others' copyright or privacy
                              rights.
                              {/* <a style={{color: '#229DD0'}} href='/test'>Learn more.</a> */}
                           </Typography>
                           <Button
                              fullWidth
                              variant="contained"
                              sx={{
                                 backgroundColor: 'var(--brand-color)', fontSize: '14px',
                                 textTransform: 'none', width: '80%', borderRadius: '6px',
                                 boxShadow: 'none', marginBottom: '35px', fontWeight: '600',
                                 marginTop: '30px',
                                 ':hover': {
                                    bgcolor: 'var(--brand-color-hover)',
                                    color: 'white',
                                    boxShadow: 'none',
                                 },
                              }}
                              className="image_update_button"
                              type="submit" value="submit"
                              // Update Password Function
                              onClick={(e) => this.UpdateIconImagePush(e)}
                           >Update Profile Image</Button>
                        </Grid>
                     </Grid>
                  </Fade>
               </Modal>
            )
         }
      } else {
         settings_main_div = (
            <div>
               <Badge
                  overlap="circular"
                  anchorOrigin={{
                     vertical: 'bottom',
                     horizontal: 'center',
                  }}
               >
                  <Avatar
                     alt="icon mage"
                     style={{
                        width: avatarSize,
                        height: avatarSize,
                        objectFit: 'cover',
                        border: 'solid 1px #C6D1DE',
                        borderRadius: '1000px'
                     }}
                     src={this.state.imageBase64}
                  />
               </Badge>
               <Box
                  sx={{
                     position: 'absolute',
                     marginLeft: editButtonMarginLeft,
                     marginTop: '-20px',
                     marginRight: 'auto',
                     height: editButtonSize,
                     width: '70px',
                     backgroundColor: 'var(--brand-color)',
                     borderRadius: '5px',
                     color: 'white',
                     transition: '0.2s',
                     cursor: 'pointer',
                     ':hover': {
                        backgroundColor: 'var(--brand-color-hover)',
                        color: 'white',
                        boxShadow: 'none',
                     },
                  }}
                  onClick={(event) => this.EditIconImageOn(event)}
               >
                  <div style={{display: 'flex'}}>
                     <p style={{
                        padding: '0px px 0px 0px', display: 'inline-block',
                        fontSize: '14px', fontWeight: '600', verticalAlign: 'bottom',
                        margin: '8px 5px auto auto'
                     }}>Edit</p>
                     <FiEdit style={{
                        padding: '9px 10px 0px 0px',
                        fontSize: '16px',
                        margin: '0px',
                        display: 'inline-block'
                     }}/>
                  </div>

               </Box>
            </div>
         )
      }
      return (
         <div>
            {settings_main_div}
         </div>
      )
   }
}

export default SettingsIconImageDiv;
